import { IRegistration } from '../../yogAdmin.duck';

export interface IRegistrationOptions {
  accommodation?: boolean;
  accommodationOptions?: {
    type?: string;
  };
  mysteryBox?: {
    enabled?: boolean;
    seva?: number;
  };
  emailTemplates?: Record<string, { template: string; subject: string }>;
  sponsorYouthProgramEnabled?: boolean;
  mahapooja?: boolean;
}

export const getRegistrationTogglesConfig = (
  registrationOptions: IRegistrationOptions | undefined,
  data: IRegistration['data'] | undefined
) => {
  const { accommodationNeeded, isStudent, hasMysteryGift } = data || {};

  return [
    {
      // Always shown, even when accommodation is disabled for the event
      condition: true,
      label: 'Do they need accommodation?',
      dataKey: 'accommodationNeeded',
      checked: !!accommodationNeeded
    },
    {
      // Follows the registration's own accommodation need rather than the event
      // config, so it stays reachable on events where accommodation is disabled
      condition: !!(
        accommodationNeeded && registrationOptions?.accommodationOptions?.type === 'Individual'
      ),
      label: 'Are they a student?',
      dataKey: 'isStudent',
      checked: !!isStudent
    },
    {
      condition: !!registrationOptions?.mysteryBox?.enabled,
      label: 'Do they have mystery gift?',
      dataKey: 'hasMysteryGift',
      checked: !!hasMysteryGift
    }
  ] as const;
};

export type RegistrationToggleKey = ReturnType<
  typeof getRegistrationTogglesConfig
>[number]['dataKey'];
